import axios from "axios";
import { bus } from "@/main.js";

// const developmentUrl = "http://localhost:4065/wp-json/wp/v2";
const productionUrl = "https://cms.casa-design.pt/wp-json/wp/v2";

const developmentUrl = "https://cms.casa-design.pt/wp-json/wp/v2";

const username = "frontend";
const password = "4Z8X2kjHh4LuEsN6KE2EkV4bts48F9";
const hash = btoa(username + ":" + password);

export const API = axios.create({
	baseURL: process.env.NODE_ENV === "development" ? developmentUrl : productionUrl,
	headers: {
		"Content-Type": "application/json",
		"Authorization": "Basic " + hash
	}
})

/**
 * Gets Params.
 */
const getParams = function (params) {
	let pathname = window.location.pathname;
	let response = { params: {} };

	if (pathname.includes('/pt', 0))
		response.params["lang"] = 'pt'
	else if (pathname.includes('/en', 0))
		response.params["lang"] = 'en'

	if (params) {
		params.forEach(param => {
			if (param.value)
				response.params[param.key] = param.value
		});
	}

	return response;
}

/**
 * Gets a entry.
 */
export const getAction = function(cpt, value, slugOrId, recursive)
{
	const type = slugOrId ? slugOrId : (Number(value) === NaN ? 'slug' : 'id');
	if(type == 'slug')
	{
		return API.get(`/${cpt}/?${type}=${value}`, getParams([{ key: "related_recursive_calls", value: recursive }])).catch( (error) => {
			bus.$emit("apiError", error);
		});
	}
	if(type == 'id')
	{
		return API.get(`/${cpt}/${value}`, getParams([{ key: "related_recursive_calls", value: recursive }])).catch((error) => {
			bus.$emit("apiError", error);
		});
	}
}

/**
 * Posts a entry.
 */
export const createAction = function(cpt, body)
{
	return API.post(`/${cpt}`, body);
}

/**
 * Gets a list (of entries).
 */
export const listAction = function (cpt, recursive, page, perPage)
{
	return API.get(`/${cpt}/`, getParams([{ key: "related_recursive_calls", value: recursive }, { key: "page", value: page }, { key: "per_page", value: perPage}] ) ).catch((error) => {
		bus.$emit("apiError", error);
	});
}

/**
 * Gets an entry or list.
 */
export const customAction = function(action)
{
	return API.get(`/${action}`);
}






// WEBPACK FOOTER //
// ./src/data/connection.js